import axios from 'axios';

/**
 * Actions
 */
export const Actions = {
    FETCH_RECLAMATION_INDICATEUR_REQUEST: 'FETCH_RECLAMATION_INDICATEUR_REQUEST',
    FETCH_RECLAMATION_INDICATEUR_SUCCESS: 'FETCH_RECLAMATION_INDICATEUR_SUCCESS',
    FETCH_RECLAMATION_INDICATEUR_FAILURE: 'FETCH_RECLAMATION_INDICATEUR_FAILURE',

    INVALIDATE_RECLAMATION_INDICATEUR: 'INVALIDATE_RECLAMATION_INDICATEUR'
};

/**
 * FETCH_RECLAMATION_INDICATEUR
 * ActionCreator pour la récupération d'un indicateur
 */
const fetchReclamationIndicateurRequest = key => ({ type: Actions.FETCH_RECLAMATION_INDICATEUR_REQUEST, key });
const fetchReclamationIndicateurSuccess = (key, valeur) => ({ type: Actions.FETCH_RECLAMATION_INDICATEUR_SUCCESS, key, valeur });
const fetchReclamationIndicateurFailure = (key, error) => ({ type: Actions.FETCH_RECLAMATION_INDICATEUR_FAILURE, key, error });
const invalidateReclamationIndicateur = key => ({ type: Actions.INVALIDATE_RECLAMATION_INDICATEUR, key });

const fetchReclamationIndicateur = key => async (dispatch, getState) => {

    if (getState().reclamation.indicateurs[key]
        && !getState().reclamation.indicateurs[key].isLoading) {

        dispatch(fetchReclamationIndicateurRequest(key));

        try {
            let response = await axios.head(`api/reclamations/${key}`);

            //console.log(`indicateur ${key} response : ${response}`, response);

            dispatch(fetchReclamationIndicateurSuccess(key, Number(response.headers['x-total-count'])));
        } catch (error) {
            console.error(`fetchReclamationIndicateur (${key}) error : `, JSON.stringify(error, null, 2));
            dispatch(fetchReclamationIndicateurFailure(key, error));
        }
    }
};

const shouldFetchReclamationIndicateur = (state, key) => {
    let indicateur = state.reclamation.indicateurs[key];

    if (!indicateur) return false;

    if (indicateur.valeur === -1) return true;
    else if (indicateur.isLoading) return false;
    else return indicateur.didInvalidate;
};

const fetchReclamationIndicateurIfNeeded = key => (dispatch, getState) => {
    if (shouldFetchReclamationIndicateur(getState(), key)) {
        return dispatch(fetchReclamationIndicateur(key));
    }
};

export const fetchReclamationsEmises = () => fetchReclamationIndicateur("emises");
export const fetchReclamationsAffectees = () => fetchReclamationIndicateur("affectees");
export const fetchReclamationsCommentaires = () => fetchReclamationIndicateur("commentaires");
export const fetchReclamationsCreees = () => fetchReclamationIndicateur("creees");
export const fetchReclamationsCloturees = () => fetchReclamationIndicateur("cloturees");
export const fetchReclamationsObservateur = () => fetchReclamationIndicateur("observateur");

export const fetchReclamationsEmisesIfNeeded = () => fetchReclamationIndicateurIfNeeded("emises");
export const fetchReclamationsAffecteesIfNeeded = () => fetchReclamationIndicateurIfNeeded("affectees");
export const fetchReclamationsCommentairesIfNeeded = () => fetchReclamationIndicateurIfNeeded("commentaires");
export const fetchReclamationsCreeesIfNeeded = () => fetchReclamationIndicateurIfNeeded("creees");
export const fetchReclamationsClotureesIfNeeded = () => fetchReclamationIndicateurIfNeeded("cloturees");
export const fetchReclamationsObservateurIfNeeded = () => fetchReclamationIndicateurIfNeeded("observateur");

export const invalidateReclamationIndicateurEmises = () => invalidateReclamationIndicateur("emises");
export const invalidateReclamationIndicateurAffectees = () => invalidateReclamationIndicateur("affectees");
export const invalidateReclamationIndicateurCommentaires = () => invalidateReclamationIndicateur("commentaires");
export const invalidateReclamationIndicateurCreees = () => invalidateReclamationIndicateur("creees");
export const invalidateReclamationIndicateurCloturees = () => invalidateReclamationIndicateur("cloturees");
export const invalidateReclamationIndicateurObservateur = () => invalidateReclamationIndicateur("observateur");